// @ts-nocheck
import React from 'react';
import Backdrop from '@mui/material/Backdrop';
import { ReactComponent as FullscreenLoaderIcon } from '../../assets/images/InfiniteLinearDot.svg';
import useGlobalLoader from '../../hooks/useGlobalLoader';

/**
 * Renders a fullscreen loading indicator when triggered by custom events
 * @returns {JSX.Element} Fullscreen loading component
 */
const FullscreenLoader = () => {
  const { isLoading: showLoader } = useGlobalLoader();

  return (
    <Backdrop
      sx={{
        color: (theme) => theme?.palette?.other?.white,
        zIndex: (theme) => theme.zIndex.modal + 1,
        transition: 'all .5s ease-in-out',
      }}
      className="backdrop-blur"
      open={showLoader}
    >
      <FullscreenLoaderIcon alt="Loading the page" color="primary" />
    </Backdrop>
  );
};

export default FullscreenLoader;
